<div id="ip-common">
  @if (headerAndFooterVisible) {
    <header>
      @if (!isProduction) {
        <lib-environment-banner></lib-environment-banner>
      }
      <lib-alert-info></lib-alert-info>
      <lib-notification-info></lib-notification-info>
      <lib-skip-to-content mainId="main-content"></lib-skip-to-content>
      <lib-site-header
        [site]="EtjansterSites.MinProfil"
        [authenticated]="false"
      ></lib-site-header>
    </header>
  }
  <div class="ip-body">
    <main id="main-content">
      <div class="container mt-5 position-relative flex-fill">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  @if (headerAndFooterVisible) {
    <lib-site-footer></lib-site-footer>
  }
</div>
